<template lang="html">
    <div>
        <h2 class="text-center py-3 bold">{{ info.title }}</h2>

        <div>
            {{ info.message }}
        </div>

        <div class="mt-5">
            <button class="btn action wide w-100" @click="clickedOk">OK</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
        }
    },
    methods: {
        clickedOk: function () {
            this.$emit('clickedOk')
        }
    }
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// invoiceMissingConf.vue?1fbff87c